import { render, staticRenderFns } from "./PagamentoGuiasTable.vue?vue&type=template&id=2bb2dc45&scoped=true"
import script from "./PagamentoGuiasTable.vue?vue&type=script&lang=js"
export * from "./PagamentoGuiasTable.vue?vue&type=script&lang=js"
import style0 from "./PagamentoGuiasTable.vue?vue&type=style&index=0&id=2bb2dc45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2dc45",
  null
  
)

export default component.exports